<template>
  <v-container>
    <v-col>
      <v-row>
        <!-- <div class="avatar-wrapper">
          <v-avatar class="ml-1 my-auto" size="40" style="cursor:pointer;">
            <img :src="data.avatar"/>
          </v-avatar>
        </div> -->
        <!-- <v-card class="ma-5">
          
          <div class="message-wrapper">
            <v-card-title>
            <div class>
              <span class="nickname">{{data.nickname}}</span>&nbsp;&nbsp;&nbsp;
              <time>{{new Date(data.createdAt) | dateFormat}}</time>
            </div>
            </v-card-title>
            <v-card-text>
            <p class="content">
              {{data.content}}
              <span
                v-if="data.replyToUser"
              >//@{{data.replyToUser.nickname}}:{{data.replyToUser.content}}</span>
            </p>
            <div class="footer-action">
              <div class="message-statis">
                <el-button type="text" @click="replyHandler">回复</el-button>
                <el-button
                  v-if="data.children && data.children.length"
                  type="text"
                  @click="toggleExpandPanel"
                >
                  {{isExpanded?`收起回复`:`${replyCount}条回复`}}
                  <i
                    :class="!isExpanded?'el-icon-arrow-down':'el-icon-arrow-up'"
                  ></i>
                </el-button>
              </div>
              <div class="append-right">
                <span class="thumb-button">
                  {{data.thumbupCount}}
                  <i class="el-icon-thumb" @click="thumbClicked(data)"></i>
                </span>
              </div>
            </div>
            <div class="editor-container" ref="editorContainer"></div>
            </v-card-text>
          </div>
        </v-card> -->
        <v-treeview :items="data">
          <template v-slot:prepend="{ data }">
        <v-card
          color="#26c6da"
          dark
          width="1100px"
          height="200px"
          class="white--text align-end"
        >
          <v-card-title>
            <span class="nickname">{{data.nickname}}</span>&nbsp;&nbsp;&nbsp;
            <time>{{new Date(data.createdAt) | dateFormat}}</time>
          </v-card-title>
      
          <v-card-text class="text-h7 font-weight-bold">
            <p class="content">
              {{item.content}}
              <span
                v-if="item.replyToUser"
              >//@{{item.replyToUser.nickname}}:{{item.replyToUser.content}}</span>
            </p>
            <div class="footer-action">
              <div class="message-statis">
                <el-button type="text" @click="replyHandler">回复</el-button>
                <el-button
                  v-if="item.children && item.children.length"
                  type="text"
                  @click="toggleExpandPanel"
                >
                  {{isExpanded?`收起回复`:`${replyCount}条回复`}}
                  <i
                    :class="!isExpanded?'el-icon-arrow-down':'el-icon-arrow-up'"
                  ></i>
                </el-button>
              </div>
              <div class="append-right">
                <span class="thumb-button">
                  {{item.thumbupCount}}
                  <i class="el-icon-thumb" @click="thumbClicked(item)"></i>
                </span>
              </div>
            </div>
            <div class="editor-container" ref="editorContainer"></div>
          </v-card-text>
      
          <v-card-actions>
            <v-list-item class="grow">
              <v-avatar color="grey darken-3">
                <img :src="data.avatar"/>
              </v-avatar>
      
              <v-list-item-content>
                <v-list-item-title>Evan You</v-list-item-title>
              </v-list-item-content>
      
              <!-- <v-row
                align="center"
                justify="end"
              >
                <v-icon class="mr-1">
                  mdi-heart
                </v-icon>
                <span class="subheading mr-2">256</span>
                <span class="mr-1">·</span>
                <v-icon class="mr-1">
                  mdi-share-variant
                </v-icon>
                <span class="subheading">45</span>
              </v-row> -->
            </v-list-item>
          </v-card-actions>
        </v-card>   
          </template>
        </v-treeview>     

      </v-row>
      <v-row>
        <message-group :dataList="data.children"></message-group>
      </v-row>
    </v-col>
  </v-container>
</template>
<script>
// import _ from 'lodash'
import { dateFormat } from '../util'

export default {
  name: 'MessageItem',

  inject: {
    level: {
      default: 1
    },
    $editor: '$editor',
    $messageTree: '$messageTree'
  },

  provide() {
    return {
      level: this.level + 1
    }
  },
  data() {
    return {
      isExpanded: this.$messageTree.expandLayer > this.level,
      hasEditor: false
    }
  },
  mounted() {
    const self = this
    this.$refs.editorContainer.addEventListener('DOMNodeInserted', function(e) {
      if (e.target === self.$editor && e.relatedNode === this) {
        self.hasEditor = true
      }
    })
    this.$refs.editorContainer.addEventListener('DOMNodeRemoved', function(e) {
      if (e.target === self.$editor && e.relatedNode === this) {
        self.hasEditor = false
      }
    })
  },
  filters: {
    dateFormat
  },
  watch: {
    '$messageTree.expandLayer': function(value) {
      this.isExpanded = value > this.level
    },
    isExpanded(value) {
      this.$messageTree.$emit('tree-expanded', this.data, value)

      if (!value) {
        if (!this.$refs.messageTreeContainer.contains(this.$editor)) {
          return
        }
        this.$editor.remove()
      }
    }
  },
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    replyCount() {
      return this.data.children && this.data.children.length
    }
  },

  methods: {
    loadMore() {
      const payload = { ...this.data }
      delete payload.children
      this.$emit('load-more', payload)
    },
    thumbClicked(item) {
      this.$messageTree.$emit('on-thumbup', item)
    },
    replyHandler() {
      if (!this.$refs.editorContainer.contains(this.$editor)) {
        this.$messageTree.showEditor()
        this.$refs.editorContainer.appendChild(this.$editor)
      }

      if (this.$messageTree.editorType === 'default') {
        this.$nextTick(() => {
          // this.$messageTree.$refs.textarea.focus()
        })
      } else {
        const payload = {
          ...this.data
        }

        delete payload.children
      this.$messageTree.$emit('on-reply', payload)
      }
    },
    toggleExpandPanel() {
      this.isExpanded = !this.isExpanded
    }
  }
}
</script>
<style lang="less" scoped>
@duration: 300ms;

dt {
  display: flex;
  .avatar-wrapper {
    margin-right: 8px;
  }
  .message-wrapper {
    width: 100%;
    font-size: 14px;

    time {
      color: #909399;
      vertical-align: middle;
    }
    .footer-action {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .append-right {
        .thumb-button {
          color: #409eff;
          cursor: pointer;
        }
      }
    }
  }
}
dd.reply-container {
  background: #fafbfc;
  padding: 20px;
  margin-top: 20px;
}
.loading-more {
  user-select: none;
  text-align: center;
  font-size: 14px;
  color: #444;
  cursor: pointer;
}

.message-reply-enter,
.message-reply-leave-to {
  transform: translateX(-100%);
}
.message-reply-active {
  transition: all @duration;
}
.message-reply-move {
  transition: all @duration;
}
.message-reply-item {
  transition: all @duration;
}
</style>

　